import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent, Children, isValidElement, cloneElement } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { B as Breadcrumb } from './Breadcrumb-BpI9SYK2.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Nav = /*#__PURE__*/styled.nav.withConfig({
  componentId: "sc-storm-ui-30061128__sc-1xvg9k0-0"
})(["", " display:flex;flex-wrap:wrap;align-items:center;color:", ";", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.breadcrumbs.color, isMobile(css(["", ";"], ({
  theme
}) => theme.typography.mobile.base)));
Nav.displayName = 'Nav';
class BreadcrumbGroup extends PureComponent {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React__default.createElement(Nav, null, Children.map(children, (child, index) => {
      if (! /*#__PURE__*/isValidElement(child)) {
        return null;
      }
      if (child.type.name !== Breadcrumb.name) {
        return /*#__PURE__*/cloneElement(child, {
          // eslint-disable-next-line react/no-array-index-key
          key: index
        });
      }
      return /*#__PURE__*/cloneElement(child, {
        key: child.props.label,
        // Set isFinal to false as default so the angle-right icon renders for single breadcrumb
        isFinal: Array.isArray(children) ? index === children.length - 1 : false
      });
    }));
  }
}
_defineProperty(BreadcrumbGroup, "propTypes", {
  /**
   * The React nodes that are rendered by the BreadcrumbGroup.
   */
  children: PT.node.isRequired
});

export { BreadcrumbGroup as B };
//# sourceMappingURL=BreadcrumbGroup-DXFGKgIb.js.map
